<template>
  <div>
    <data-table
      ref="haveVote"
      :module-info="moduleInfoResult"
      :tb-columns="tbColumns"
      :toolbar-btns="listpageBtnsA"
      :on-list-data-before-load="onListDataBeforeLoad"
      :on-cell-click="onCellClick"
    />
    <dialog-statisics></dialog-statisics>
  </div>
</template>

<script>
import dialogStatisics from './dialogStatisics'
export default {
    components: {
        dialogStatisics
    },
    props: {
        id: { type: String, default: function() { return '' } },
        row: { type: Object, default: function() { return {} } }
    },
    data() {
        return {
            moduleInfoResult: {
                listDataUrl: '/hygl/voteResult/listdata'
            },
            tbColumns: [
                {
                    field: 'index',
                    title: '序号',
                    width: '45px',
                    align: 'center',
                    valign: 'middle'
                },
                {
                    field: 'deptName',
                    title: '部门',
                    align: 'left',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' }},
                    sortable: true
                },
                {
                    field: 'voteName',
                    title: '投票人',
                    width: '211px',
                    align: 'left',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' }},
                    sortable: true
                },
                {
                    field: 'phoneNumber',
                    title: '联系方式',
                    width: '211px',
                    align: 'left',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' }},
                    sortable: true
                },
                {
                    field: 'column_operate',
                    title: '投票结果',
                    align: 'center',
                    valign: 'middle'
                }
            ],
            listpageBtnsA: [
                {
                    btnName: '查看',
                    btnIcon: 'chart.svg',
                    btnClick: 'checkVote()',
                    btnPermission: 'editObject',
                    id: 'btn_edit',
                    btnType: 'column',
                    btnI18nCode: 'look'
                }
            ]
        }
    },
    computed: {

    },
    created() {
    },
    beforeDestroy() {

    },
    mounted() {
        this.$refs.haveVote.$el.childNodes[0].style = 'display:none'
    },
    methods: {
        onListDataBeforeLoad($scope, qparams) {
            qparams.urlsearch = '' // orgCode:plat error: 当前实体类不包含名为orgCode的属性!  暂定未''
            qparams.searchMap = {
                status: 1,
                voteId: this.id,
                choiceStatus: 2
            }
            // qparams.urlsearch = 'orgCode:'+ $scope.loginUser.orgCode +';account:'+ $scope.loginUser.personAccount +';voteStatus:1'
        },
        checkVote() {
            this.$bus.emit('openstatistics', this.row)
        },
        onCellClick() {
        }
    }
}
</script>

<style scoped lang="scss">
.el-table-toolbar {
  display: none;
}
</style>
